import { render, staticRenderFns } from "./ManageSucessOccurrenceTypeListView.vue?vue&type=template&id=0b503486"
import script from "./ManageSucessOccurrenceTypeListView.vue?vue&type=script&lang=ts"
export * from "./ManageSucessOccurrenceTypeListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports